module.exports = __webpack_public_path__ + "static/media/graph-21.079076f9.svg";